import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import React from "react";
import { IoArrowForwardOutline } from "react-icons/io5";
import Link from "next/link";

const bodyComponent = {
  heading4: ({ children }) => (
    <h4 className="text-base text-[#272B2E]">{children}</h4>
  ),
  heading5: ({ children }) => (
    <h5 className="text-base text-[#272B2E]">{children}</h5>
  ),
  heading6: ({ children }) => (
    <h6 className="text-base text-[#272B2E]">{children}</h6>
  ),
  paragraph: ({ children }) => (
    <p className="text-base text-[#272B2E]">{children}</p>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
};

const TopContent = ({ data, readMoreLabel }) => {
  return (
    <div className="">
      <PrismicNextImage
        field={data?.data?.image}
        fallbackAlt=""
        className="min-h-[203px] max-h-[203px] object-cover"
      />
      <div className="mt-[16px] mb-[8px]">
        <PrismicRichText
          field={data?.data?.title}
          components={{
            heading1: ({ children }) => (
              <h2 className="title-font title-small text-[#1F2223]">
                {children}
              </h2>
            ),
            heading2: ({ children }) => (
              <h2 className="title-font title-small text-[#1F2223]">
                {children}
              </h2>
            ),
            heading3: ({ children }) => (
              <h2 className="title-font title-small text-[#1F2223]">
                {children}
              </h2>
            ),
          }}
        />
      </div>
      <div className="mt-1 md:mt-[10px] pb-[6px]">
        <p className="text-base text-[#272B2E] line-clamp-4">
          {data?.data.summary}
        </p>
      </div>
      <Link
        href={`${data.url}`}
        className="flex items-center gap-1 text-[#B78562] text-base font-bold my-[10px]"
      >
        <span>{readMoreLabel}</span>
        <IoArrowForwardOutline size={20} color="#B78562" />
      </Link>
    </div>
  );
};

export default TopContent;
